export const TIMELINE = {
    LEVEL_LABEL: { key: 'LEVEL_LABEL', value: 'Level {{level}}' },
    REASON_LABEL: { key: 'REASON_LABEL', value: 'Reason' },
    APPROVED_LABEL: { key: 'APPROVED_LABEL', value: 'Approved' },
    REJECTED_LABEL: { key: 'REJECTED_LABEL', value: 'Rejected' },
    NOTIFIED_USERS_LABEL: { key: 'NOTIFIED_USERS_LABEL', value: 'Notified users' },
    WAITING_FOR_APPROVAL_LABEL: { key: 'WAITING_FOR_APPROVAL_LABEL', value: 'Waiting for approval' },
}